import React, { Component } from "react";
import styled, { css } from "styled-components";

import Gettext from "./common/Gettext";
import { gaReducer } from "./GA";
import FacebookIcon from "./Icons/Social/Facebook";
import TwitterIcon from "./Icons/Social/Twitter";
import EmailIcon from "./Icons/Social/Email";
import SMSIcon from "./Icons/Social/SMS";

const Button = styled.button`
  display: block;
  padding: 0;
  font-size: ${({ theme }) =>
    theme.locale === "ar" ? theme.minFontSize : "12px"};
  line-height: 2;
  text-transform: uppercase;
  text-decoration: none;
  color: #797979;
  background: none;
  border: none;
  cursor: pointer;

  @media (max-width: 320px) {
    font-size: ${({ theme }) =>
      theme.locale === "ar" ? theme.minFontSize : "10px"};
  }

  &:not(:last-child) {
    margin-right: 38px;
  }

  @media (max-width: 540px) {
    &:not(:last-child) {
      margin-right: 20px;
    }
  }
`;

const TopContainer = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;
  width: 49px;
  height: 49px;
  border-radius: 50%;

  ${({ id }) =>
    id === "facebook" &&
    css`
      background-color: #3b5998;
    `}

  ${({ id }) =>
    id === "twitter" &&
    css`
      background-color: #55acee;
    `}

  ${({ id }) =>
    id === "email" &&
    css`
      background-color: #dc4e41;
    `}

  ${({ id }) =>
    id === "sms" &&
    css`
      background-color: #8dc700;
    `}
`;

const FacebookIconContainer = styled.div`
  width: 9px;
  height: 19px;
  color: #ffffff;
`;

const TwitterIconContainer = styled.div`
  width: 23px;
  height: 19px;
  color: #ffffff;
`;

const EmailIconContainer = styled.div`
  width: 24px;
  height: 16px;
  color: #ffffff;
`;

const SMSIconContainer = styled.div`
  width: 25px;
  height: 22px;
  color: #ffffff;
`;

class ReferralsLink extends Component {
  constructor(props) {
    super(props);

    this.onClick = this.onClick.bind(this);
  }

  onClick(e) {
    gaReducer("CLICKBTN_REF_SHARE", {
      clickId: e.currentTarget.id,
      pagePath: window.document.location.pathname
    });

    e.preventDefault();
    if (typeof this.props.onClick === "function") {
      this.props.onClick();
    }
  }

  render() {
    const { name, id, desktop, isIndexPage, hideName } = this.props;

    const icon = () => {
      switch (id) {
        case "facebook":
          return (
            <FacebookIconContainer>
              <FacebookIcon />
            </FacebookIconContainer>
          );
        case "twitter":
          return (
            <TwitterIconContainer>
              <TwitterIcon />
            </TwitterIconContainer>
          );
        case "email":
          return (
            <EmailIconContainer>
              <EmailIcon />
            </EmailIconContainer>
          );
        case "sms":
          return (
            <SMSIconContainer>
              <SMSIcon />
            </SMSIconContainer>
          );
        default:
          return;
      }
    };

    return (
      <Button desktop={desktop} title={id} id={id} onClick={this.onClick}>
        <TopContainer id={id}>{icon()}</TopContainer>
        {!desktop && !isIndexPage && !hideName && <Gettext>{name}</Gettext>}
      </Button>
    );
  }
}

export default ReferralsLink;



// WEBPACK FOOTER //
// ./src/components/ReferralsLink.js